import queryString from "query-string";

export default (history) => {
    const search = history.location.search;

    return queryString.parse(search);
};


// WEBPACK FOOTER //
// ./src/helpers/routes/parseSearchQuery.js